import { faTiktok, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { faFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faTwitch } from '@fortawesome/free-brands-svg-icons/faTwitch';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef } from 'react';
import { imgOvertimeLogoWhiteSvg } from '~/src/images';
import styles from '~/src/lib/styles.json';
import './Footer.scss';
import FooterLinks from './FooterLinks';

const Footer = () => {
	const footerRef = useRef<HTMLDivElement>();
	useEffect(() => {
		if (typeof window !== 'undefined') {
			if (location.search.includes('embed')) {
				footerRef.current?.remove();
			}
		}
	});

	return (
		<div
			ref={footerRef}
			style={{
				gridColumn: 'full',
				background: styles.COLOR.BRAND_PRIMARY,
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
			}}
		>
			<footer
				style={{
					display: 'grid',
					gridTemplateColumns: '1fr',
					gridGap: styles.SIZE.GAP,
					width: '100%',
					maxWidth: styles.SIZE.CONTENT_WIDTH,
					padding: `${styles.SIZE.GAP_2X} ${styles.SIZE.GAP}`,
					textAlign: 'center',
					flexShrink: '0',
				}}
			>
				<div className="desktop-only">
					<a href="/">
						<img
							src={imgOvertimeLogoWhiteSvg}
							style={{
								width: '76px',
								opacity: 0.7,
								transition: 'all 0.1s ease',
							}}
						/>
					</a>
				</div>

				<div>
					<FooterLinks>
						<a href="/">Home</a>
						<a href={'https://shop.overtime.tv'}>Shop</a>
						<a href="/about">About</a>
						<a href={'https://www.teamworkonline.com/sports-technology-jobs/Overtime-overtime-elite-jobs/overtime'}>
							Jobs
						</a>
						<a href={'https://partners.overtime.tv'}>Advertise</a>
						<a href="/contact">Contact</a>
					</FooterLinks>
					<div
						style={{
							display: 'grid',
							gridTemplateColumns: '1fr',
							alignItems: 'center',
							justifyContent: 'center',
							margin: `${styles.SIZE.GAP_2X} 0`,
							gridRowGap: styles.SIZE.GAP_2X,
						}}
					>
						<FooterLinks>
							<a href="https://instagram.com/overtime" title="Overtime Instagram Page">
								<FontAwesomeIcon icon={faInstagram} size="2x" />
							</a>
							<a href="https://twitter.com/overtime" title="Overtime Twitter Page">
								<FontAwesomeIcon icon={faXTwitter} size="2x" />
							</a>
							<a href="https://www.facebook.com/getovertime" title="Overtime Facebook Page">
								<FontAwesomeIcon icon={faFacebook} size="2x" />
							</a>
							<a href="https://www.youtube.com/channel/UCPHKMJbis1c0R7d7WJQ35tA" title="Overtime YouTube Page">
								<FontAwesomeIcon icon={faYoutube} size="2x" />
							</a>
							<a href="http://twitch.tv/overtime" title="Overtime Twitch Page">
								<FontAwesomeIcon icon={faTwitch} size="2x" />
							</a>
							<a href="https://www.tiktok.com/@overtime" title="Overtime TikTok Page">
								<FontAwesomeIcon icon={faTiktok} size="2x" />
							</a>
						</FooterLinks>
						<FooterLinks>
							<div>Brooklyn</div>
							<div>Los Angeles</div>
							<div>Chicago</div>
							<div>Atlanta</div>
						</FooterLinks>
						<FooterLinks>
							<a href="/terms">Terms</a>
							<a href="/campaigns">Campaigns</a>
							<a href="/privacy">Privacy</a>
							<a href="/copyright">DMCA</a>
							<a href="/accessibility">Accessibility</a>
						</FooterLinks>{' '}
					</div>
				</div>
				<div
					className="copyright"
					style={{
						color: styles.COLOR.DESATURATED_WHITE_TEXT,
						textTransform: 'uppercase',
						fontSize: '10px',
						fontFamily: styles.FONT.HIGHLIGHT,
						margin: `${styles.SIZE.GAP_2X} 0`,
					}}
				>
					© {new Date().getFullYear()} Overtime Sports, Inc. All Rights Reserved.
				</div>
			</footer>
		</div>
	);
};

export default Footer;
